import type { TFunction } from 'i18next'
import type { AccessGrant } from '../api/accessGrants'

/**
 * Where a grant comes from (spec 2026-10-06-07): "Manual", or "From the lease
 * BAIL-12 of 12/2024", "From the occupant link", with "via <colocation>" when
 * the link is held by a party group the member belongs to. Uses the `access`
 * namespace.
 */
export function grantOriginLabel(grant: AccessGrant, t: TFunction, language: string): string {
    if (grant.source !== 'derived' || !grant.origin) return t('access:origin.manual')
    const origin = grant.origin
    let label: string
    if (origin.kind === 'lease') {
        const code = origin.contract_name || origin.contract_code || ''
        label = origin.contract_start_date
            ? t('access:origin.lease', {
                  code,
                  date: new Date(origin.contract_start_date).toLocaleDateString(language, {
                      month: '2-digit',
                      year: 'numeric',
                  }),
              })
            : t('access:origin.lease_undated', { code })
    } else {
        label = t(`access:origin.${origin.kind}`)
    }
    if (origin.party?.name) label += ` ${t('access:origin.via', { party: origin.party.name })}`
    return label
}
